export default (context) => {
    if(context.testData.type==='third-party') return 
    if(context.timeLeft <= 0 || Date.now() >= context.timeEnd){ 
        context.restTime = false; return context.submitTest('TEST_TIME_OUT')
    }
}